import React, { useState, useEffect, useContext } from "react";
import LoaderScreen from "./LoaderScreen";
import MenuScreen from "./MenuScreen";
import Keyboard from "./Keyboard";
import PopularSearch from "./MarkupGrid";
import DetailsScreen from "../Module/Search/SearchDetailsScreen";
import noDataFound from "../assets/NoSearchResultFound1.png";
import ErrorScreen from "./ErrorScreen";
import ModalScreen from "./ModalScreen";
import loginimg from "../assets/loginimg.png";
import logoutIcon from "../assets/Logout-Icon.png";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import { Translate, Languages } from "./LanguageChanger";
import { useDebounce } from "../utils/useDebounce";
import {
  getSearchContent,
  getSearchRecommendations,
} from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { AppContext } from "../AppContext";
import { use } from "react";
import HomeDetailsScreen from "../Module/VodDetails/VodDetailScreen";
import LiveEventDetailsScreen from "../Module/LiveEvent/LiveEventDetailsScreen";
import GallaryDetailsScreen from "../Module/GallaryDetail/GallaryDetailScreen";
import TvRadioDetailsScreen from "../Module/TvRadio/TvRadioDetailsScreen";

let resolution = window.RESOLUTION;

const SearchScreen = ({ navigate, isLogedIn }) => {
  const lang = localStorage.getItem("AppLanguage");
  const [selectedLanguage, setSelectedLanguage] = useState(lang);
  const getTranslation = (key) => {
    return Languages[selectedLanguage]?.[key] || Languages.English[key];
  };
  const [input, setInput] = useState("");
  const [popularSearchConfig, setPopularSearchConfig] = useState([]);
  const [state, setState] = useState({
    loading: true,
    error: false,
    shouldFocusToKeyBoard: true,
    shouldFocusGrid: false,
    shouldCloseMenu: true,
    shouldShowModal: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
  });
  const [screen, setScreen] = useState();
  const [data, setData] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const debouncedPageNumber = useDebounce(pageNumber, 500);
  const { sourceContext, setSourceContext } = useContext(AppContext);



  // Handle keyboard input
  const handleKeyPress = (key) => {
    // Check if the key is a special key (space, del, clear)
    if (typeof key === "string") {
      switch (key.toLowerCase()) {
        case "space":
          if (input !== "") {
            setInput((prev) => prev + " ");
          }
          return;
        case "del":
          if (input !== "") {
            setInput((prev) => {
              const updatedInput = prev?.slice(0, -1);
              if (updatedInput.length === 0) {
                loadData();
                return "";
              }
              return updatedInput;
            });
          }
          return;
        case "clear":
          if (input !== "") {
            setInput("");
            loadData();
          }
          return;
        default:
          break;
      }
    }

    // Handle regular keys
    if (input === getTranslation("Popular-Search") || input === "") {
      setInput("");
    }
    setInput((prev) => prev + key);
  };

  // Rest of your component code remains the same...
  const handleRightButton = () => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToKeyBoard: true,
      shouldFocusGrid: false,
      shouldCloseMenu: true,
    }));
    MenuScreen.SetFocus(true);
  };

  const navigateToScreen = (screen, data = {}) => {
    console.log(data, screen, "hjhjhj")
    setScreen(screen);
    setData(data);
  };

  const {
    loading,
    error,
    shouldFocusToKeyBoard,
    shouldFocusGrid,
    shouldCloseMenu,
    shouldShowModal,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
  } = state;

  // const handleFocusChange = (component)=>{
  //   if(component === "keyboard" && !shouldFocusToKeyBoard){
  //     setState(prev => ({ ...prev, shouldFocusToKeyBoard: true, shouldFocusGrid: false}));
  //   } else if (component === "grid" && !shouldFocusGrid){
  //     setState(prev => ({ ...prev, shouldFocusToKeyBoard: false, shouldFocusGrid: true}))
  //   }
  // }

  const handleFocusChange = (component) => {
    if (error) {
      if (!shouldFocusToKeyBoard) {
        setState(prev => ({
          ...prev,
          shouldFocusToKeyBoard: true,
          shouldFocusGrid: false,
        }));
      }
      return;
    }

    if (component === "keyboard" && !shouldFocusToKeyBoard) {
      setState(prev => ({
        ...prev,
        shouldFocusToKeyBoard: true,
        shouldFocusGrid: false,
      }));
    } else if (component === "grid" && !shouldFocusGrid) {
      setState(prev => ({
        ...prev,
        shouldFocusToKeyBoard: false,
        shouldFocusGrid: true,
      }));
    }
  };

  const handleClear = () => {
    setInput("");
  };

  const handleLogout = (p) => {

    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: false,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: true,
      shouldFocusToKeyBoard: false,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Logout", "Cancel"],
    }));

    MenuScreen.SetFocus(true);
  };

  const handleLogin = (p) => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: false,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Login to Continue",
      errDescription: "LoginContinue",
      errIcon: loginimg,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Login", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const modalOKButtonHandler = (action) => {
    switch (action) {
      case "Login":
        // Matomo Event
        // sendTestMatomoEvent({
        //   eventCategory: "Page",
        //   eventAction: "View",
        //   eventName: "LoginPopup",
        // });

        navigate("LoginScreen");
        break;
      case "Logout":
        console.log("Logout....");
        localStorage.removeItem("JWTToken");
        localStorage.removeItem("userInfo");
        const getCountry = localStorage.getItem("country");
        let headers = {
          iskid: "0",
          Langid: "1",
          "Content-Type": "application/json",
          country: getCountry,
        };
        MenuScreen.ReseTfocus(4);
        MenuScreen.SetFocus(true);
        handleMenuselection("Login");
        break;
      case "Yes":
        console.log("Exit....Application");
        exitApplication();
        break;
      default:
        break;
    }
  };

  const exitApplication = () => {
    if (window.tizen) {
      sendTestMatomoEvent({ action_name: `App - End`, url: "search" });
      window.tizen.application.getCurrentApplication().exit();
    } else {
      sendTestMatomoEvent({ action_name: `App - End`, url: "search" });
      window.close();
    }
  };

  const handleExit = () => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Yes", "No"],
    }));
    MenuScreen.SetFocus(true);
  };

  const modalCANCELButtonHandler = () => {
    MenuScreen.ReseTfocus(2);
    setState((prevState) => ({
      ...prevState,
      shouldShowModal: false,
      shouldFocusToKeyBoard: true,
    }));
  };

  const handleItemSelected = (item) => {
    console.log("Selected item:", sourceContext, item);
    console.log("datatype", item)
    sendItemSelectedMatomoEvent(item);

    const VOD = item?.type == 0
    const AOD = item?.type === 1 || item?.media_type === 1
    const AudioLiveTv = item?.type == 1 && item?.still_live == 1
    const LiveTV = item.type === 0 && item.still_live === 1;
    const LiveEvent = item.type === 9  //review from other all checks below logic
    const GallaryDetailsScreen = item?.type === 4 || item?.type === 5 || item?.type == 6 || item?.type === 7
    console.log("text", AOD)

    if (GallaryDetailsScreen) {
      navigateToScreen("GallaryDetailsScreen", item)
      return;
    }


    if (AudioLiveTv || LiveTV) {
      console.log("DiTV")
      navigateToScreen("TvRadioDetailsScreen", item);
      return;
    }
    if (LiveEvent) {
      console.log("DiTV")
      navigateToScreen("LiveEventDetailsScreen", item);
      return;
    }
    if (VOD || AOD) {
      console.log("text1", VOD)
      navigateToScreen("HomeDetailsScreen", item)
      return;
    }


    // navigateToScreen("SearchDetailsScreen", item);

  };

  const getMediaType1 = (itemDetails) => {
    if (!itemDetails) return "Unknown";

    const { type, is_paid } = itemDetails;
    console.log(type, is_paid, itemDetails, "checkingMediaType1")

    if (type === 1) return "AOD";

    if (type === 0) {
      switch (is_paid) {
        case 0:
          return "VOD";
        case 1:
          return "SVOD";
        case 2:
        case 3:
          return "TVOD";
        default:
          return "";
      }
    }

    return "";
  };


  const sendItemSelectedMatomoEvent = async (item) => {
    console.log("checkingSearch", item)

    const mediaType1 = getMediaType1(item);

    if (
      item?.is_paid === 2 &&
      ["Movies", "Shows", "Shorts", "Documentaries"].includes(item?.category_title)
    ) {
      await sendTestMatomoEvent({
        eventCategory: "ContentDetailPage",
        eventAction: "Select",
        eventName: `HowDoIWatch(${item?.id}/${item?.title}(${mediaType1}))`,
      })
    } else if (item.category_title === "Games") {
      await sendTestMatomoEvent({
        eventCategory: "ContentDetailPage",
        eventAction: "Select",
        eventName: `HowDoIWatch(${item?.id}/${item?.title})`,
      })
    }
    // Matomo Event
    await sendTestMatomoEvent({
      eventCategory: "Search",
      eventAction: "ContentSelected",
      eventName: `${item?.id}/${item?.title}`,
    });
  };


  // const callBack = (p) => {
  //   if (p === "keyboard") {
  //     setState((prevState) => ({
  //       ...prevState,
  //       shouldFocusToKeyBoard: false,
  //       shouldFocusGrid: true,
  //     }));
  //   } else if (p === "Grid") {
  //     setState((prevState) => ({
  //       ...prevState,
  //       shouldFocusToKeyBoard: true,
  //       shouldFocusGrid: false,
  //     }));
  //   } else if (p === "Back") {
  //     console.log("handleBack....", screen);
  //     setState((prevState) => ({
  //       ...prevState,
  //       shouldFocusToKeyBoard: false,
  //       shouldFocusGrid: false,
  //       shouldCloseMenu: false,
  //     }));
  //     MenuScreen.SetFocus(false);
  //   }
  // };

  const callBack = (p) => {
    if (p === "keyboard") {
      if (error) {
        setState(prevState => ({
          ...prevState,
          shouldFocusToKeyBoard: true,
          shouldFocusGrid: false,
        }));
        return;
      }

      setState(prevState => ({
        ...prevState,
        shouldFocusToKeyBoard: false,
        shouldFocusGrid: true,
      }));
    } else if (p === "Grid") {
      setState(prevState => ({
        ...prevState,
        shouldFocusToKeyBoard: true,
        shouldFocusGrid: false,
      }));
    } else if (p === "Back") {
      console.log("handleBack....", screen);
      setState(prevState => ({
        ...prevState,
        shouldFocusToKeyBoard: false,
        shouldFocusGrid: false,
        shouldCloseMenu: false,
      }));
      MenuScreen.SetFocus(false);
    }
  };

  // Filter function to exclude specific categories
  const excludedCategoriesFilter = (item) => !(item?.category_title === "Magazines and Journals" || item?.category_title === "PDF" || item?.category_title === "E Book & Journals");

  // useEffect(() => {
  const fetchData = async () => {
    console.log("fetchData called with pageNumber:", pageNumber, "and input:", input);
    const getCountry = localStorage.getItem("country");
    let headers = {
      iskid: "0",
      Langid: "1",
      "Content-Type": "application/json",
      page: pageNumber,
      search: input,
      country: getCountry,
      // age: "12",
    };

    try {
      let fetchedSearchData = null;
      setState((prevState) => ({
        ...prevState,
        loading: true,
      }));

      if (input === "Popular Search" || input === "" || input === null) {
        fetchedSearchData = await getSearchRecommendations(pageNumber);
        if (fetchedSearchData && Array.isArray(fetchedSearchData.data)) {
          // setPopularSearchConfig(fetchedSearchData.data.filter(excludedCategoriesFilter));
          setPopularSearchConfig((prev) => ([...prev, ...fetchedSearchData.data.filter(excludedCategoriesFilter)]));

        }
        setState((prevState) => ({
          ...prevState,
          loading: false,
          error: false,
        }));
      } else {
        if (!input || input.length < 3) {
          // Show recommendations instead of an empty/no-data state
          const recs = await getSearchRecommendations(pageNumber);
          console.log("recs...", recs);
          if (recs && Array.isArray(recs.data)) {
            setPopularSearchConfig(recs.data.filter(excludedCategoriesFilter));
          }
          setState((prevState) => ({
            ...prevState,
            loading: false,
            error: false,
          }));
          return;
        }

        // Active search (3+ chars)
        fetchedSearchData = await getSearchContent(pageNumber, input);

        // If API didn't return data, set list to empty and show no-data only for active searches
        if (!fetchedSearchData || !Array.isArray(fetchedSearchData.data)) {
          setPopularSearchConfig([]);
          setState((prevState) => ({
            ...prevState,
            loading: false,
            error: false,
          }));
          return;
        }

        if (pageNumber === 1) {
          setPopularSearchConfig(fetchedSearchData.data.filter(excludedCategoriesFilter))
        } else {
          setPopularSearchConfig((prev) => ([...prev, ...fetchedSearchData.data.filter(excludedCategoriesFilter)]));
        }

        console.log("huiiu")
        setState((prevState) => ({
          ...prevState,
          loading: false,
          error: pageNumber === 1 && fetchedSearchData.data.length === 0,
          shouldFocusToKeyBoard:
            pageNumber === 1 && fetchedSearchData.data.length === 0
              ? true
              : prevState.shouldFocusToKeyBoard,
          shouldFocusGrid:
            pageNumber === 1 && fetchedSearchData.data.length === 0
              ? false
              : prevState.shouldFocusGrid,
        }));

      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setState((prevState) => ({
        ...prevState,
        loading: false,
        error: true,
      }));
    }
  };

  useEffect(() => {



    setTimeout(() => {
      console.log("hiddi")
      fetchData();
    }, 200);
  }, [pageNumber]);


  // const loadData = async (val = null) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     loading: true,
  //   }));

  //   const page = Number(localStorage.getItem("pagination"));
  //   const getCountry = localStorage.getItem("country");
  //   let headers = {
  //     // iskid: "0",
  //     // Langid: "1",
  //     // "Content-Type": "application/json",
  //     page: pageNumber,
  //     search: val,
  //     // country: getCountry,
  //     // age: "12",
  //   };

  //   try {
  //     let fetchedSearchData = null;

  //     if (val === "Popular Search" || val === null) {
  //       fetchedSearchData = await getSearchRecommendations(pageNumber, headers);
  //     } else if (val !== null) {
  //       // Only call search API for queries with 3+ characters
  //       if (!input || input.length < 3) {
  //           setState((prevState) => ({
  //             ...prevState,
  //             loading: false,
  //             error: false,
  //           }));
  //           return;
  //         }

  //         // Safe to call the search API for queries with length >= 3
  //         fetchedSearchData = await getSearchContent(pageNumber, input);
  //       }

  //       // If API didn't return data, avoid updating state to 'no data'
  //       if (!fetchedSearchData || !Array.isArray(fetchedSearchData.data)) {
  //         setState((prevState) => ({
  //           ...prevState,
  //           loading: false,
  //           error: false,
  //         }));
  //         return;
  //       // fetchedSearchData = await getSearchContent(pageNumber, val, headers);
  //     }

  //     //  if(input === "Popular Search" || input === "" || input === null){
  //     //     fetchedSearchData = await getSearchRecommendations(pageNumber, headers);
  //     //   } else {
  //     //     fetchedSearchData = await getSearchContent(pageNumber, input, headers);
  //     //   }

  //     setPopularSearchConfig(fetchedSearchData.data);
  //     setState((prevState) => ({
  //       ...prevState,
  //       loading: false,
  //       error: fetchedSearchData?.data?.length > 0 ? false : true,
  //     }));
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     setState((prevState) => ({
  //       ...prevState,
  //       loading: false,
  //       error: true,
  //     }));
  //   }
  // };

  // useEffect(() => {
  //     loadData();
  // }, [debouncedPageNumber]);

  const loadData = async (val = null) => {
    if (val !== null && val.length < 3) {
      return;
    }

    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));

    // const page = Number(localStorage.getItem("pagination"));
    // const getCountry = localStorage.getItem("country");

    let headers = {
      page: pageNumber,
      search: val,
    };

    try {
      let fetchedSearchData = null;

      if (val === "Popular Search" || val === null) {
        fetchedSearchData = await getSearchRecommendations(pageNumber, headers);
      } else {

        fetchedSearchData = await getSearchContent(pageNumber, val, headers);
      }


      if (!fetchedSearchData || !Array.isArray(fetchedSearchData.data)) {
        setState((prevState) => ({
          ...prevState,
          loading: false,

        }));
        return;
      }
      console.log("fetchedSearchData...", fetchedSearchData.data.filter(excludedCategoriesFilter));
      setPopularSearchConfig(fetchedSearchData.data.filter(excludedCategoriesFilter));
      setState((prevState) => ({
        ...prevState,
        loading: false,
        error: fetchedSearchData.data.length === 0,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
      setState((prevState) => ({
        ...prevState,
        loading: false,
        error: true,
      }));
    }
  };


  const detailToDetail = (recommendationItem) => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    navigateToScreen("", recommendationItem);
    setTimeout(function () {
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));

      const VOD = recommendationItem?.type == 0
      const AOD = recommendationItem?.type === 1 || recommendationItem?.media_type === 1
      const AudioLiveTv = recommendationItem?.type == 1 && recommendationItem?.still_live == 1
      const LiveTV = recommendationItem.type === 0 && recommendationItem.still_live === 1;
      const LiveEvent = recommendationItem.type === 9  //review from other all checks below logic
      const GallaryDetailsScreen = recommendationItem?.type === 4 || recommendationItem?.type === 5 || recommendationItem?.type == 6 || recommendationItem?.type === 7
      console.log("text", AOD)

      if (GallaryDetailsScreen) {
        navigateToScreen("GallaryDetailsScreen", recommendationItem)
        return;
      }


      if (AudioLiveTv || LiveTV) {
        console.log("DiTV")
        navigateToScreen("TvRadioDetailsScreen", recommendationItem);
        return;
      }
      if (LiveEvent) {
        console.log("DiTV")
        navigateToScreen("LiveEventDetailsScreen", recommendationItem);
        return;
      }
      if (VOD || AOD) {
        console.log("text1", VOD)
        navigateToScreen("HomeDetailsScreen", recommendationItem)
        return;
      }

    }, 100);
  };

  const handleBack = (screenName) => {
    console.log("handleBack....", screen, screenName);
    // setScreen("");
    setPageNumber(1);
    setState((prevState) => ({
      ...prevState,
      loading: false,
      shouldFocusToKeyBoard: false,
      shouldFocusGrid: true,
      shouldCloseMenu: true,
    }));
    // Reset both screen and data states
    // setScreen(null);
    // setData({});
    setScreen(screenName);
  };

  const handleMenuselection = (selectedMenu) => {
    switch (selectedMenu) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Profile":
        navigate("ProfileScreen");
        break;
      case "Search":
        navigate("SearchScreen");
        break;
      case "Live":
        navigate("LiveScreen");
        break;
      case "LiveEvents":
        navigate("LiveEventsScreen");
        break;
      case "Home":
        navigate("HomePage");
        break;
      case "Watchlist":
        break;
      case "Categories":
        navigate("CategoryScreen");
        break;
      case "Settings":
        navigate("SettingsScreen");
        break;
      case "Logout":
        break;
      default:
        break;
    }
  };

  //   useEffect(() => {
  //   return () => {
  //     // Cleanup when component unmounts
  //     setScreen(null);
  //     setData({});
  //   };
  // }, []);

  useEffect(() => {
    setSourceContext("Search");

    // Matomo Event
    sendTestMatomoEvent({
      eventCategory: "Page",
      eventAction: "View",
      eventName: "Search",
      url: "search",
    });
  }, []);

  useEffect(() => {
    if (!input) return;

    const timer = setTimeout(() => {
      loadData(input);
      setPageNumber(1);
    }, 500);

    sendTestMatomoEvent({
      eventCategory: "Search",
      eventAction: `Search - ${input}`,
      url: `search?${input}`,
    });

    return () => clearTimeout(timer);
  }, [input]);



  const keyboardConfig = [
    ["a", "b", "c", "d", "e", "f"],
    ["g", "h", "i", "j", "k", "l"],
    ["m", "n", "o", "p", "q", "r"],
    ["s", "t", "u", "v", "w", "x"],
    ["y", "z", "1", "2", "3", "4"],
    ["5", "6", "7", "8", "9", "0"],
    ["SPACE", "DEL", "CLEAR"],
  ];


  console.log("pageNumber...", setPageNumber, pageNumber, data)

  if (screen === "HomeDetailsScreen") {
    console.log("hooo")
    return (
      <HomeDetailsScreen
        handleBack={handleBack}
        navigate={navigate}
        data={data}
        // isLiveScreen = {data.still_live }
        isLogedIn={isLogedIn}
        detailToDetail={detailToDetail}
      />
    );

  }
  else if (screen === "TvRadioDetailsScreen") {
    console.log("hooo")
    return (
      <TvRadioDetailsScreen
        handleBack={handleBack}
        navigate={navigate}
        data={data}
        // isLiveScreen = {data.still_live }
        isLogedIn={isLogedIn}
        detailToDetail={detailToDetail}
      />
    );

  }
  if (screen == "LiveEventDetailsScreen") {
    return (
      <LiveEventDetailsScreen
        handleBack={handleBack}
        navigate={navigate}
        data={data}
        // isLiveScreen = {data.still_live }
        isLogedIn={isLogedIn}
        detailToDetail={detailToDetail} />
    );
  }

  else if (screen === "GallaryDetailsScreen") {
    console.log("hooo")
    return (
      <GallaryDetailsScreen
        handleBack={handleBack}
        navigate={navigate}
        data={data}
        // isLiveScreen = {data.still_live }
        isLogedIn={isLogedIn}
        detailToDetail={detailToDetail}
      />
    );

  }
  else {
    return (
      <div style={styles.screenContainer}>
        {loading && <LoaderScreen screen={screen === "" ? "" : "SearchPage"} />}
        {/* {!loading && ( */}
        <>
          <div style={styles.inputContainer}>
            {input ? (
              <input
                type="text"
                value={input}
                name="text"
                style={styles.input}
                readOnly
              />
            ) : (
              <input
                type="text"
                value={`${getTranslation("Popular-Search")}`}
                readOnly
                style={styles.input}
              />
            )}
          </div>

          <div
            style={styles.keyboardContainer}
            onMouseEnter={() => handleFocusChange("keyboard")}
          >
            <Keyboard
              keys={keyboardConfig}
              onKeyPress={handleKeyPress}
              onClear={handleClear}
              shouldFocus={shouldFocusToKeyBoard}
              selectionColor={shouldFocusToKeyBoard ? "#EC008C" : "#0E1653"}
              callBack={callBack}
              onFocusNeeded={() => handleFocusChange("keyboard")}
            />
          </div>

          <div style={styles.popularSearchContainer}>
            <PopularSearch
              items={popularSearchConfig}
              onItemSelected={handleItemSelected}
              rowWidth="100%"
              rowHeight={300}
              columnWidth={resolution === "FHD" ? 228 : 152}
              columnHeight={resolution === "FHD" ? 291 : 194}
              itemWidth={resolution === "FHD" ? 227 : 120}
              itemHeight={resolution === "FHD" ? 290 : 160}
              numberOfColumnsEachRow={4}
              numberOfDefaultRows={3}
              selectionColor={shouldFocusGrid ? "#fff" : "transparent"}
              selectionStyle="border"
              gapBetweenColumns={15}
              gapBetweenRows={resolution === "FHD" ? 21 : 7}
              columnBgColorOrImage="#0000"
              rowBgColorOrImage="#0000"
              shouldScrollHorizontally={false}
              shouldScrollVertically={true}
              scrollDuration={300}
              GridXCordinate={45}
              GridYCordinate={0}
              shouldFocus={shouldFocusGrid}
              callBack={callBack}
              onFocusNeeded={() => handleFocusChange("grid")}
              itemComponentName="SearchWidget"
              isLogedIn={isLogedIn}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              loading={loading}
            />
          </div>

          <MenuScreen
            navigate={navigateToScreen}
            handleMenuselection={handleMenuselection}
            shouldCloseMenu={shouldCloseMenu}
            handleRightButton={handleRightButton}
            isLogedIn={isLogedIn}
            appNavigate={navigate}
            handleLogout={handleLogout}
            handleExit={handleExit}
            handleLogin={handleLogin}
          />

          <div style={{ position: "absolute" }}>
            <ModalScreen
              shouldShowError={shouldShowModal}
              errTitle={errTitle}
              errDescription={errDescription}
              errIcon={errIcon}
              button={button}
              iconWdth={iconWdth}
              iconHeight={iconHeight}
              modalOKButtonHandler={modalOKButtonHandler}
              modalCANCELButtonHandler={modalCANCELButtonHandler}
            />
          </div>

          <div
            style={{
              ...styles.popularSearchContainer,
              marginLeft: "300px",
              marginTop: "0px",
            }}
          >
            <ErrorScreen
              errorIcon={noDataFound}
              disply={error ? "flex" : "none"}
              bgcolor="transparent"
            />
          </div>
        </>
      </div>
    );
  }
};

const styles = {
  screenContainer: {
    backgroundImage: `url(${solidbackgroundimg})`,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#000",
    color: "#fff",
    height: "100vh",
    width: "100vw",
    position: "absolute",
    margin: "0px",
    padding: "0px",
    boxSizing: "border-box",
    maraginLeft: resolution === "FHD" ? "20px" : "13px",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  inputContainer: {
    position: "absolute",
    marginLeft: resolution === "FHD" ? "820px" : "467px",
    marginTop: resolution === "FHD" ? "30px" : "40px",
  },
  input: {
    width: resolution === "FHD" ? "700px" : "467px",
    height: resolution === "FHD" ? "50px" : "33px",
    fontSize: resolution === "FHD" ? "28px" : "17px",
    textAlign: "left",
    borderRadius: resolution === "FHD" ? "10px" : "7px",
    border: "1px solid transparent", //#fff',
    backgroundColor: "transparent", //'#333',
    color: "#fff",
    position: "absolute",
  },
  keyboardContainer: {
    position: "absolute",
    marginLeft: resolution === "FHD" ? "154px" : "103px",
    marginTop: resolution === "FHD" ? "72px" : "48px",
    zIndex: 1,
  },
  popularSearchContainer: {
    marginTop: resolution === "FHD" ? "94px" : "73px",
    marginLeft: resolution === "FHD" ? "767px" : "460px",
    position: "absolute",
    display: "flex",
    background: "transparent",
    // width: resolution === "FHD" ? "1230p" : "820px",
    width: "100vw",
    // height: resolution === "FHD" ? "963px" : "642px",
    height: "100%",
    overflow: "hidden",
    boxSizing: "border-box",
    overflowY: "auto",
  },
};

export default SearchScreen;